module.exports = __webpack_public_path__ + "img/readMaterial.6cf217c0.svg";